module.exports = __webpack_public_path__ + "static/media/linkedin-logo.8edb043b.svg";